import React from 'react';
import { Navigate } from 'react-router-dom';
import useAccountsApprover from '../hooks/useAccountsApprover';

// Wraps a page that only the accounts agent's approvers may open (Accounts Agent, QuickBooks Customers and its
// Link customers wizard). Used INSIDE <PrivateRoute requireSuperAdmin>, so sign-in and superadmin are already settled here.
// Anyone else who reaches the URL is sent to the dashboard, as PrivateRoute does for a superadmin-only page.
// The API refuses them the data as well (404) — this only stops an empty page being shown.
const AccountsApproverRoute = ({ children }) => {
    const { loaded, isApprover } = useAccountsApprover();
    if (!loaded) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}><div>Loading...</div></div>;
    if (!isApprover) return <Navigate to="/dashboard" replace />;
    return children;
};

export default AccountsApproverRoute;
